const colors = {
  main: '#3486A0',
  main70: '#70A9BC', //opacity70
  main30: '#C2DBE3', //opacity30
  dark1: '#303030', //darkest
  dark2: '#545454',
  light1: '#959595',
  light2: '#D9D9D9', //defalut
  light3: '#F0F0F0', //lightest
  light4: '#FBFBFB', //most lightest
  white: '#FFFFFF',
  programmers: '#64B4AC',
  baekjoon: '#3578BF',
  yellow: '#FFE500', //star
  red: '#FF4545',
  codeReview: '#CCDEF2',
};

export const theme = {
  colors,
};
